<!-- auction-list.component.html -->
<div class="auction-grid">
  <ng-container *ngIf="!loading && !individualAuctionItems.present.length">
    <div class="auction-grid__empty">
      <span class="auction-grid__empty-mark">—</span>
      <p class="auction-grid__empty-text">
        No lots available right now. Check back soon.
      </p>
    </div>
  </ng-container>

  <div class="auction-grid__item" *ngFor="let item of individualAuctionItems.present">
    <app-auction-card [item]="item" [auctionType]="'current'"></app-auction-card>
  </div>
</div>

<app-loader *ngIf="loading"></app-loader>